import { useState } from 'react';

export function useImportQuizToWorkspaceDialogState() {
  const [isOpen, setIsOpen] = useState(false);
  return { isOpen, setIsOpen };
}
